import { render, staticRenderFns } from "./recapAsk.vue?vue&type=template&id=9d75e4d2"
import script from "./recapAsk.vue?vue&type=script&lang=js"
export * from "./recapAsk.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports